"use strict";

exports.__esModule = true;
exports.default = User;
var _preact = require("preact");
function User(_ref) {
  var i18n = _ref.i18n,
    logout = _ref.logout,
    username = _ref.username;
  return (0, _preact.h)(_preact.Fragment, null, (0, _preact.h)("span", {
    className: "uppy-ProviderBrowser-user",
    key: "username"
  }, username), (0, _preact.h)("button", {
    type: "button",
    onClick: logout,
    className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
    key: "logout"
  }, i18n('logOut')));
}